import styled from 'styled-components';

export const WrapperStyled = styled.div`
  padding-top: 2rem;
`;
